/* Teslimat/dispatch olaylarının GÖRÜNEN metni — TEK KAYNAK.
   Aynı olay iki kanala çıkar: kayan kart (DeliveryNotificationSlide) ve masaüstü
   bildirimi (App.jsx → showFleetDesktopNotification). İkisi ayrı sözlük tutsaydı
   kullanıcı aynı olayı iki farklı başlıkla görürdü; bu yüzden başlık/gövde üretimi
   burada durur ve iki tüketici de buradan okur. */

import { DispatchEventType } from '../config/environment';

/* Masaüstü bildirimi tipi bu önekle üretilir; resolveFleetNotificationLink öneki tanır
   ve teslimatlar sayfasına indirir (bkz. utils/fleetNotificationLink.js). Önek aynı
   zamanda Notification `tag`'ini olay türüne göre ayırır: kurye atandı ile kabul edildi
   üst üste binmez, ama aynı türün ardışık tekrarları biner. */
export const DELIVERY_NOTIFICATION_TYPE_PREFIX = 'delivery:';

const DISPATCH_CONFIG = {
    [DispatchEventType.OrderReceived]:       { icon: 'package', color: '#22c55e', title: 'Sipariş Alındı', kind: 'OrderReceived' },
    [DispatchEventType.CourierAssigned]:     { icon: 'bike', color: '#8b5cf6', title: 'Kurye Atandı', kind: 'CourierAssigned' },
    [DispatchEventType.CourierNotFound]:     { icon: 'x', color: '#ef4444', title: 'Kurye Bulunamadı', kind: 'CourierNotFound' },
    [DispatchEventType.CourierAccepted]:     { icon: 'check', color: '#22c55e', title: 'Kabul Edildi', kind: 'CourierAccepted' },
    [DispatchEventType.CourierRejected]:     { icon: 'ban', color: '#f97316', title: 'Reddedildi', kind: 'CourierRejected' },
    [DispatchEventType.AssignmentExpired]:   { icon: 'clock', color: '#eab308', title: 'Süre Doldu', kind: 'AssignmentExpired' },
    [DispatchEventType.RegionMatchFailed]:   { icon: 'map', color: '#ef4444', title: 'Bölge Eşleşmedi', kind: 'RegionMatchFailed' },
    [DispatchEventType.ReassignmentStarted]: { icon: 'refresh', color: '#06b6d4', title: 'Yeniden Atama', kind: 'ReassignmentStarted' },
    [DispatchEventType.InsufficientBalance]: { icon: 'wallet', color: '#dc2626', title: 'Yetersiz Bakiye', kind: 'InsufficientBalance' },
    [DispatchEventType.OrderDelivered]:      { icon: 'check', color: '#22c55e', title: 'Teslim Edildi', kind: 'OrderDelivered' },
    [DispatchEventType.PartnerNotReady]:     { icon: 'store', color: '#f97316', title: 'Partner Hazır Değil', kind: 'PartnerNotReady' },
    [DispatchEventType.FleetNotReady]:       { icon: 'truck', color: '#f97316', title: 'Filo Hazır Değil', kind: 'FleetNotReady' },
    [DispatchEventType.CourierNotReady]:     { icon: 'bike', color: '#f97316', title: 'Kurye Hazır Değil', kind: 'CourierNotReady' },
};

const ACTION_CONFIG = {
    CourierAssigned: { icon: 'bike', color: '#8b5cf6', title: 'Kurye Atandı', kind: 'CourierAssigned' },
    Cancelled:       { icon: 'x', color: '#ef4444', title: 'İptal Edildi', kind: 'Cancelled' },
};

const STATUS_CONFIG = {
    Pending:                   { icon: 'clock', color: '#6b7280', title: 'Beklemede', kind: 'Pending' },
    Dispatching:               { icon: 'refresh', color: '#06b6d4', title: 'Atama Yapılıyor', kind: 'Dispatching' },
    AwaitingCourierAcceptance: { icon: 'hourglass', color: '#eab308', title: 'Kurye Onay Bekliyor', kind: 'AwaitingCourierAcceptance' },
    Assigned:                  { icon: 'bike', color: '#8b5cf6', title: 'Kurye Atandı', kind: 'Assigned' },
    PickingUp:                 { icon: 'package', color: '#f59e0b', title: 'Teslim Alınıyor', kind: 'PickingUp' },
    PickedUp:                  { icon: 'package', color: '#8b5cf6', title: 'Teslim Alındı', kind: 'PickedUp' },
    Delivering:                { icon: 'truck', color: '#22c55e', title: 'Teslimatta', kind: 'Delivering' },
    Delivered:                 { icon: 'check', color: '#22c55e', title: 'Teslim Edildi', kind: 'Delivered' },
    Cancelled:                 { icon: 'x', color: '#ef4444', title: 'İptal Edildi', kind: 'Cancelled' },
    Failed:                    { icon: 'x', color: '#ef4444', title: 'Başarısız', kind: 'Failed' },
    PartnerPreparing:          { icon: 'store', color: '#f97316', title: 'Partner Hazırlanıyor', kind: 'PartnerPreparing' },
    KitchenReady:              { icon: 'utensils', color: '#22c55e', title: 'Sipariş Hazır', kind: 'KitchenReady' },
    InsufficientBalance:       { icon: 'wallet', color: '#dc2626', title: 'Yetersiz Bakiye', kind: 'InsufficientBalance' },
};

const DEFAULT_CONFIG = { icon: 'megaphone', color: '#6b7280', title: 'Teslimat', kind: 'Update' };

/* Panelde gösterilen sipariş numarası — TEK KAYNAK (teslimatlar tablosu da aynı kuralı uygular).
   Pazaryeri dışı siparişte (POS/masa/Hızlıyo) `externalOrderId` sipariş GUID'idir; okunabilir
   numara `internalOrderNumber`'dır. Sıralama bu yüzden internal ÖNCE. İkisi de yoksa null döner
   ve numara satırı hiç çizilmez — GUID göstermektense hiç göstermemek doğrudur. */
export function resolveNotificationOrderNo(n) {
    return n?.internalOrderNumber || n?.externalOrderId || null;
}

export function getDeliveryNotificationConfig(n) {
    if (n.eventType && DISPATCH_CONFIG[n.eventType]) {
        return DISPATCH_CONFIG[n.eventType];
    }
    if (n.action === 'StatusChanged' && n.newStatus && STATUS_CONFIG[n.newStatus]) {
        return STATUS_CONFIG[n.newStatus];
    }
    return ACTION_CONFIG[n.action] || DEFAULT_CONFIG;
}

export function buildDeliveryNotificationMessage(n) {
    if (n.eventType && n.message) {
        return n.message;
    }

    const cn = n.courierName;
    const oid = resolveNotificationOrderNo(n);

    if (n.eventType) {
        const cfg = DISPATCH_CONFIG[n.eventType];
        if (cfg) {
            const parts = [];
            if (cn) parts.push(cn);
            if (oid) parts.push(`#${oid}`);
            return parts.length > 0 ? parts.join(', ') : cfg.title;
        }
    }

    if (n.action === 'StatusChanged' && n.newStatus) {
        switch (n.newStatus) {
            case 'Pending':
                return oid ? `#${oid} beklemede` : 'Sipariş beklemede';
            case 'Dispatching':
                return oid ? `#${oid} için kurye aranıyor` : 'Kurye aranıyor';
            case 'AwaitingCourierAcceptance':
                return cn ? `${cn} onay bekliyor` : 'Kurye onayı bekleniyor';
            case 'Assigned':
                return cn ? `${cn} siparişe atandı` : 'Kurye siparişe atandı';
            case 'PickingUp':
                return cn ? `${cn} teslim alıyor` : 'Kurye teslim alıyor';
            case 'PickedUp':
                return cn ? `${cn} siparişi aldı` : 'Kurye siparişi aldı';
            case 'Delivering':
                return cn ? `${cn} teslimat yolunda` : 'Kurye teslimat yolunda';
            case 'Delivered':
                return cn ? `${cn} siparişi teslim etti` : 'Sipariş teslim edildi';
            case 'Cancelled':
                return 'Sipariş iptal edildi';
            case 'Failed':
                return 'Teslimat başarısız oldu';
            case 'PartnerPreparing':
                return oid ? `#${oid} partner hazırlanıyor` : 'Partner hazırlanıyor';
            case 'KitchenReady':
                return oid ? `#${oid} hazır, kurye teslim alabilir` : 'Sipariş hazır, kurye teslim alabilir';
            case 'InsufficientBalance':
                return 'Yetersiz bakiye — sipariş bekletiliyor';
            default:
                /* Ham statü adı BASILMAZ: backend enum adları İngilizce ("KitchenReady") ve
                   sözlüğe eklenmeyen her yeni statü kullanıcıya İngilizce sızıyordu. Bilinmeyen
                   statüde genel Türkçe metin verilir; eksik çeviri log'da değil, sözlükte kapanır. */
                return oid ? `#${oid} durumu güncellendi` : 'Teslimat durumu güncellendi';
        }
    }

    if (n.action === 'CourierAssigned') {
        return cn ? `${cn} siparişe atandı` : 'Kurye siparişe atandı';
    }
    if (n.action === 'Cancelled') {
        return 'Sipariş iptal edildi';
    }

    return 'Teslimat güncellemesi alındı';
}

/** Masaüstü bildirimi için tip anahtarı: `delivery:<olay türü>`. */
export function deliveryNotificationType(n) {
    return `${DELIVERY_NOTIFICATION_TYPE_PREFIX}${getDeliveryNotificationConfig(n).kind}`;
}

/** Kayan kartla birebir aynı başlık + gövde; masaüstü bildirimi bunu kullanır. */
export function buildDeliveryDesktopNotification(n) {
    const cfg = getDeliveryNotificationConfig(n);
    const parts = [buildDeliveryNotificationMessage(n)];
    if (n.partnerName) parts.push(n.partnerName);
    return {
        type: deliveryNotificationType(n),
        title: cfg.title,
        body: parts.join(', '),
    };
}
